import React, { useState, useEffect } from 'react';
import OTPInput from './src';
import './index.css';
import { useNavigate,useSearchParams, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { drtsAPIURL } from '../Constant';


function App() {

  const history = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useParams();

    const [{ otp, numInputs, separator, minLength, maxLength, placeholder, inputType }, setConfig] = React.useState({
        otp: '',
        numInputs: 6,
        separator: '-',
        minLength: 0,
        maxLength: 40,
        placeholder: '',
        inputType: 'text',
    });
    const handleOTPChange = (otp) => {
        setConfig((prevConfig) => ({ ...prevConfig, otp }));
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        setConfig((prevConfig) => ({ ...prevConfig, [name]: value }));
    };
    const handleNumInputsChange = (event) => {
        let numInputs = event.target.valueAsNumber;
        if (numInputs < minLength || numInputs > maxLength) {
            numInputs = 6;
            console.error(`Please enter a value between ${minLength} and ${maxLength}`);
        }
        setConfig((prevConfig) => ({ ...prevConfig, numInputs }));
    };
    const clearOtp = () => {
        setConfig((prevConfig) => ({ ...prevConfig, otp: '' }));
    };

    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [oneGovTokenExists, setOneGovTokenExists] = useState(false);

    if(params.token!==undefined && params.token!==''){
      if (!oneGovTokenExists) setOneGovTokenExists(true);
    }


    const handleSubmit = (event) => {
        event.preventDefault();

        const body_o=JSON.stringify({
          otp: otp,
          user_id:localStorage.getItem('user_id_temp'),          
        });
        
        loginRequest(drtsAPIURL+'otp_verification',body_o);

    };
    
    async function loginRequest(url,this_body) {//alert(otp);
      try {
        await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: this_body,
        })
          .then((response) => {

          if (response.ok) { //alert(response.status+" -- "+response.ok);
        
            return response.json();
             }
          else{ //alert(response.status+" -not- "+response.ok);
            
            return response.json().then(text => { 
              //throw new Error(text) 
              if(text.message!=undefined){
                toast.error("Request failed: "+text.message);
                }
                else{
                  toast.error("Request failed: Could not connect to the server");  
                }
            });
            
          }

          })
          .then((data) => {
           

              if (data.status!=null&&data.status==true&&data.status!=undefined) {


                toast.success("Login Successful...");

                 setIsLoggedIn(true);            
              
                localStorage.setItem("login", true);
                localStorage.setItem("authenticated", true);
                localStorage.setItem('login_datetime', Date.now());              
                localStorage.setItem('token', data.token);
                localStorage.setItem('phone_number', data.user_phone_number);
                localStorage.setItem("user_id", data.user.id);                  
                localStorage.setItem('omang', data.user_omang);
                localStorage.setItem("firstname", data.user.firstname);
                localStorage.setItem("surname", data.user.surname);

                localStorage.removeItem('user_id_temp');

                history(`${process.env.PUBLIC_URL}/eservices/PaymentsEServices`);

                            
            } else {
            
              //console.log('error other -- '+JSON.stringify(data));
            if (data.status!=null&&data.status!=undefined) {
                toast.error("Error: "+data.message);
             }
             else{
               toast.error("Ooops! An unexpected error occurred. Try again shortly.");
             }
              
              setIsLoggedIn(false); 

            }
          })
      } catch (error) {
        //console.log(error.message);
        toast.error("Authentication failed.. "+error.message);
        setIsLoggedIn(false);
      }
    }

    return (<div className="containero">
    
      <div className="viewo">
      {oneGovTokenExists ? (
        <h3>{"..."}</h3>
       ) :(<div className="cardo">
          <form onSubmit={handleSubmit}>
            <p>Enter verification code</p>
            <div className="margin-top--small">
              <OTPInput inputStyle="inputStyle" numInputs={numInputs} onChange={handleOTPChange} renderSeparator={<span>{separator}</span>} value={otp} placeholder={placeholder} inputType={inputType} renderInput={(props) => <input {...props}/>} shouldAutoFocus/>
            </div>
            <div className="btn-rowo">
              <button className="btno margin-top--large" type="button" disabled={otp.trim() === ''} onClick={clearOtp}>
                Clear
              </button>
              <button className="btno margin-top--large" disabled={otp.length < numInputs}>
                Submit
              </button>
            </div>
          </form>
        </div>)}

      </div>
      <ToastContainer />
    </div>);
}
export default App;
